module.exports = __webpack_public_path__ + "static/spokoj_main_2-70491684127cfbd03a887ef82f01e51c.png";